// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore, disableNetwork, enableNetwork } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFunctions} from "firebase/functions";
import { getMessaging, isSupported } from "firebase/messaging";
import { getStorage } from "firebase/storage";



// ⚠️ Reemplazá estos valores con los tuyos
const firebaseConfig = {
  apiKey: "AIzaSyD2lYmJzZBPydRCUXP2nyzGQkzoXs0dJi4",
  authDomain: "stock-urualum.firebaseapp.com",
  projectId: "stock-urualum",
  storageBucket: "stock-urualum.firebasestorage.app",
  messagingSenderId: "539303926650",
  appId: "1:539303926650:web:0e183219d06270652b14c3"
};
// Inicializa Firebase
const app = initializeApp(firebaseConfig);
console.log("[firebase.js] init projectId:", app.options.projectId, "app name:", app.name);

// Helper: obtener instancia de Messaging sólo si el navegador lo soporta
export const messagingPromise = (async () => {
  const supported = await isSupported();
  if (!supported) {
    console.log("[firebase.js] FCM no soportado en este navegador");
    return null;
  }
  try {
    const messaging = getMessaging(app);
    console.log("[firebase.js] Messaging inicializado");
    return messaging;
  } catch (err) {
    console.error("[firebase.js] Error inicializando messaging", err);
    return null;
  }
})();



// Exportá la instancia de Firestore
export const db = getFirestore(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
// NUEVO: exportar Functions (ajustá la región si usás otra)
export const functions = getFunctions(app, "us-central1");
export const storage = getStorage(app);

// Cuando la app vuelve de segundo plano (PWA suspendida), los listeners de
// Firestore pueden "reanudarse" mostrando el último snapshot en memoria,
// que puede haber quedado desactualizado mientras la app estaba oculta.
// Forzamos un corte/reconexión para que todos los onSnapshot activos
// resincronicen desde el servidor.
let reconnecting = false;
document.addEventListener("visibilitychange", () => {
  if (document.visibilityState !== "visible" || reconnecting) return;
  reconnecting = true;
  disableNetwork(db)
    .then(() => enableNetwork(db))
    .catch((err) => console.error("[firebase.js] error reconectando Firestore:", err))
    .finally(() => { reconnecting = false; });
});

